/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-01-06 10:03:26
 * @LastEditTime : 2025-01-06 10:42:07
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\utils\decimal.js
 */
import { Decimal } from "decimal.js";
// args第一位为被操作数据

//加法
function add(...args) {
    let result = new Decimal(args[0]);
    for (let i = 1; i < args.length; i++) {
        result = result.add(new Decimal(args[i]));
    }
    result =new Decimal(result).toFixed(2)
    return result;
}
//减法
function sub(...args) {
    let result = new Decimal(args[0]);
    for (let i = 1; i < args.length; i++) {
        result = result.sub(new Decimal(args[i]));
    }
    result =new Decimal(result).toFixed(2)
    return result;
}
//乘法
function mul(...args) {
    let result = new Decimal(args[0]);
    for (let i = 1; i < args.length; i++) {
        result = result.mul(new Decimal(args[i]));
    }
    result =new Decimal(result).toFixed(2)
    return result;
}
//除法
function div(...args) {
    let result = new Decimal(args[0]);
    for (let i = 1; i < args.length; i++) {
        result = result.div(new Decimal(args[i]));
    }
    result =new Decimal(result).toFixed(2)
    return result;
}

export default {
    add,
    sub,
    mul,
    div
};
